import {
  Upload, Map, LayoutDashboard, ListChecks, Wand2, Target, Trophy, Medal, GraduationCap,
} from 'lucide-react';

// Primary navigation items shared by the desktop bar and the mobile drawer.
// - labelKey: i18n key resolved with t()
// - auth: true => only shown to logged-in users
// - testid / testidMobile: stable data-testids (mobile differs for a few items)
export const NAV_ITEMS = [
  { to: '/dashboard', labelKey: 'nav.dashboard', Icon: LayoutDashboard, testid: 'nav-dashboard', auth: true },
  { to: '/analyze', labelKey: 'nav.analyze', Icon: Upload, testid: 'nav-analyze', auth: true },
  { to: '/sessions', labelKey: 'nav.sessions', Icon: ListChecks, testid: 'nav-sessions', auth: true },
  { to: '/goals', labelKey: 'gamify.navGoals', Icon: Target, testid: 'nav-goals', testidMobile: 'nav-goals-mobile', auth: true },
  { to: '/challenges', labelKey: 'gamify.challenges.navChallenges', Icon: Trophy, testid: 'nav-challenges', testidMobile: 'nav-challenges-mobile', auth: true },
  { to: '/leaderboard', labelKey: 'nav.leaderboard', Icon: Medal, testid: 'nav-leaderboard', testidMobile: 'nav-leaderboard-mobile', auth: true },
  { to: '/gear-advisor', labelKey: 'nav.gearAi', Icon: Wand2, testid: 'nav-gear-ai' },
  { to: '/kaia', labelKey: 'coach.nav', Icon: GraduationCap, testid: 'nav-coach-kaia', testidMobile: 'nav-coach-kaia-mobile' },
  { to: '/spots', labelKey: 'nav.spots', Icon: Map, testid: 'nav-spots' },
];
